import Urls from '../api/Configuration';
import { LoginRequest } from '../api/dtos/auth/LoginRequest';
import LoginResponse from '../api/dtos/auth/LoginResponse';
import LogOutRequest from '../api/dtos/auth/LogOutRequest';
import { passwordRequest } from '../api/dtos/auth/PasswordRequest';
import RefreshRequest from '../api/dtos/auth/RefreshRequest';
import EmptyApiResponse from '../api/dtos/EmptyApiResponse';
import ServiceLocator from './ServiceLocator';

export default class AuthService {

    public Login(request: LoginRequest): Promise<LoginResponse> {
        return ServiceLocator.ApiClient.Post<LoginResponse>(Urls.LOGIN, request);
    }

    public Refresh(request: RefreshRequest): Promise<LoginResponse> {
        return ServiceLocator.ApiClient.Post<LoginResponse>(Urls.REFRESH_TOKEN, request);
    }
    public async Logout(request: LogOutRequest): Promise<EmptyApiResponse> {
        return ServiceLocator.ApiClient.Post<EmptyApiResponse>(Urls.LOGOUT, request);
    }

    public InvitePassword(request: passwordRequest): Promise<EmptyApiResponse> {
        return ServiceLocator.ApiClient.Post<EmptyApiResponse>(Urls.ADMIN_INVITE_PASSWORD, request);
    }
}
